export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/social_media_design.b52e385.svg";